export default __webpack_public_path__ + "static/media/clock-new.9c8f88c7.png";